const SLHomeAddressPopupSceneType = { // 弹窗出现场景
  SLHomeAddressPopupSceneTypeNone: 0, // 未知
  SLHomeAddressPopupSceneTypeFirstLogin: 1, // 首次登录
  SLHomeAddressPopupSceneTypeNoService: 2, // 不在服务范围: 已废弃
  SLHomeAddressPopupSceneTypeColdStart: 3, // 非首次安装的冷启动
  SLHomeAddressPopupSceneTypeClickAddressBar: 4, // 点击地址栏
  SLHomeAddressPopupSceneTypeClickGoGoGo: 5, // 点击逛一逛
};

const SLAddressPopUpListType = {
  SLAddressPopUpListTypeUserAddressTitle: -1, // 收货地址标题: 前端使用，不与埋点对齐
  SLAddressPopUpListTypeChoiceCurrent: 1, // 选择当前位置
  SLAddressPopUpListTypeMapView: 2, // 地图非气泡区
  SLAddressPopUpListTypeUserAddress: 3, // 直接使用收货地址
  SLAddressPopUpListTypeLastPoi: 4, // 上次选择的地址
  SLAddressPopUpListTypeChoiceOther: 5, // 选择其他位置: 废弃，使用地图气泡代替
  SLAddressPopUpListTypeAddUserAddress: 6, // 新增收货地址
  SLAddressPopUpListTypeEditUserAddress: 7, // 编辑收货地址, 有编辑按钮时一定存在收货地址，即在浮层2.0下 当type:3时，需要变更为type:7
  SLAddressPopUpListTypeEditUserAddressBtn: 8, // 点击编辑收货地址按钮后的弹层--编辑按钮
  SLAddressPopUpListTypeDeleteUserAddressBtn: 9, // 点击编辑收货地址按钮后的弹层--删除按钮
  SLAddressPopUpListTypeCancelUserAddressBtn: 10, // 点击编辑收货地址按钮后的弹层--取消按钮
};

// 地址选择类型
const SLAddressPopUpChoiceType = {
  SLAddressPopUpChoiceTypeCurrentLocation: 1, // 使用我现时的位置
  SLAddressPopUpChoiceTypeCustomLocation: 2, // 手动输入其他位置
};

// 地址选择类型
const SLGetLocationType = {
  ActualLocation: 1, // 当前定位
  SelectedLocation: 2, // 地图选址
  UserAddress: 3, // 收货地址
};

/// 首页定位状态
/// 0 : 初始化：未启动首页定位 地址栏展示'定位中'
/// 1 : 定位中：真实定位中 or 逆地理中 地址栏展示'定位中'
/// 2 : 定位完成，但是逆地理失败：地址栏展示'未选择地址'
/// 3 : 使用默认旺角地址
/// 4 : 匹配到真实定位300m内的收货地址
/// 5 : 真实定位poi : 逆地理成功
/// 6 : 在地图中选择的地点
/// 7 ：手动选择的用户收货地址
/// 8 : 定位失败后使用最近一次真实定位缓存
/// 9 ： 定位失败后使用最近一次地图选点
/// 10 ： 定位失败后使用最近一次收货地址记录
/// 11 ： 切换用户后收货地址已过期，此时只能取到经纬度和地址名称，其他信息已被清空
const SLHomeLocationStatus = {
  SLHomeLocationStatusUnknow: 0, // 未知, 初始化状态
  SLHomeLocationStatusPrepare: 1, // 准备开始定位
  SLHomeLocationStatusActualRegeoFailed: 2, // 定位成功，但是获取地址信息失败，地址栏依然展示未选择地址
  SLHomeLocationStatusDefauleLocation: 3, // 使用默认的坐标（旺角）
  SLHomeLocationStatusActualAddress: 4, // 匹配到真实定位300m内的收货地址
  SLHomeLocationStatusActualLocation: 5, // 使用真实定位poi
  SLHomeLocationStatusSelectedLocation: 6, // 主动在地图中选择的地点
  SLHomeLocationStatusSelectedAddress: 7, // 主动选择的收货地址
  SLHomeLocationStatusUsingCachedActualLocation: 8, // 使用最近一次定位缓存
  SLHomeLocationStatusUsingCachedSelectedLocation: 9, // 使用最近一次地图选点
  SLHomeLocationStatusUsingCachedSelectedAddress: 10, // 使用最近一次收货地址记录
  SLHomeLocationStatusOverdueAddress: 11, // 切换用户后收货地址已过期，此时只能取到经纬度和地址名称，其他信息已被清空
};

const UserAddressDtosChannelKey = 'com.keeta.home.address.channle';
const UserAddressDtosCacheKey = 'com.keeta.home.address.popup.dtos.cache';
const SelectPopupShowEvent = 'select_popup_show_event';

export {
  SLHomeAddressPopupSceneType,
  SLAddressPopUpListType,
  SLAddressPopUpChoiceType,
  SLGetLocationType,
  SLHomeLocationStatus,
  UserAddressDtosChannelKey,
  UserAddressDtosCacheKey,
  SelectPopupShowEvent
};
